import dayjs from "dayjs";
require('dayjs/locale/de')
require('dayjs/locale/en')
require('dayjs/locale/sv')

import utc from 'dayjs/plugin/utc';
import advancedFormat from "dayjs/plugin/advancedFormat";
import weekday from "dayjs/plugin/weekday";
import duration from 'dayjs/plugin/duration';
import weekOfYear from "dayjs/plugin/weekOfYear";
import customParseFormat from "dayjs/plugin/customParseFormat";
import quarterOfYear from "dayjs/plugin/quarterOfYear";
import localizedFormat from "dayjs/plugin/localizedFormat";
import isoWeek from "dayjs/plugin/isoWeek";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(utc)
dayjs.extend(advancedFormat)
dayjs.extend(weekday)
dayjs.extend(duration)
dayjs.extend(weekOfYear)
dayjs.extend(relativeTime)
dayjs.extend(customParseFormat)
dayjs.extend(quarterOfYear)
dayjs.extend(localizedFormat)
dayjs.extend(isoWeek)

export default {
    setLocale(code){
        dayjs.locale(code);
    },
    custom(date, format){
        if(!format)
            format = "YYYY-MM-DD";
        var formated = dayjs(date).format(format);
        return formated == "Invalid Date" ? "": formated;
    },
    stringToReadableFormat(dateString) {
        // Removed code below, in case you ever want to return "torsdag 13 augusti 2020" then uncomment code below
        // // Parse string into date object
        // const date = new Date(dateString);

        // // Convert to readable date string
        // const options = {
        //     weekday: "long",
        //     year: "numeric",
        //     month: "long",
        //     day: "numeric"
        // };
        // let readableDateString = date.toLocaleDateString("sv-SE", options);

        // // Convert first letter in weekday into uppercase
        // readableDateString =
        //     readableDateString.charAt(0).toUpperCase() +
        //     readableDateString.slice(1);

        // return readableDateString;
        return this.stringToIsoDateOnly(dateString);
    },
    stringToIsoDateOnly(dateString) {
        // Parse string into date object
        const date = new Date(dateString);

        // Convert to readable date string
        const options = {
            year: "numeric",
            month: "2-digit",
            day: "2-digit"
        };
        const isoDateString = date.toLocaleDateString("sv-SE", options);
        return isoDateString;
    },
    utcDateToSwedishDate(utcDate) {
        var swedishDate = dayjs(utcDate).add(2, "hours");
        return swedishDate;
    },
    utcDateToLocalDate(utcDate)
    {
        var localDate = dayjs(utcDate).add(this.userTimezone(), "hours");
        return localDate;
    },
    dateNow() {
        return dayjs().format("YYYY-MM-DD HH:mm");
    },
    dateNowWithoutTime() {
        return dayjs().format("YYYY-MM-DD");
    },
    dateNowTimestamp() {
        return dayjs().format("x");
    },
    dateNowUtc() {
        return dayjs().toISOString();
    },
    dateToTimestamp(date) {
        return dayjs(date).format("x");
    },
    timestampToDays(time) {
        return parseInt(time / 86400);
    },
    dateToDateWithoutHour(date) {
        return dayjs(date).format("YYYY-MM-DD");
    },
    dateToDateWithoutSeconds(date) {
        if (dayjs(date).format("YYYY-MM-DD HH:mm") != "Invalid date") {
            return dayjs(date).format("YYYY-MM-DD HH:mm");
        } else {
            const newDate = parseInt(date);
            return dayjs(newDate).format("YYYY-MM-DD HH:mm");
        }
    },
    utcDateToDateWithoutSeconds(date) {
        return dayjs.utc(date).local().format("YYYY-MM-DD HH:mm");
        //return  this.dateToDateWithoutSeconds(this.utcDateToLocalDate(date));
    },
    // Difference in seconds between two date objects
    // positive value means dateA is a earlier datetime than dateB
    secondDifferenceBetweenDates(dateA, dateB) {
        const a = dayjs(dateA);
        const b = dayjs(dateB);
        return dayjs(b).diff(dayjs(a), "seconds");
    },
    // Difference in days between two date objects
    dayDifferenceBetweenDates(dateA, dateB) {
        const a = dayjs(dateA);
        const b = dayjs(dateB);
        return dayjs(b).diff(dayjs(a), "days");
    },
    daysBefore(date, days) {
        if (!days && days !== 0) {
            days = 1;
        }
        return dayjs(date)
            .subtract(days, "days")
            .format("YYYY-MM-DD HH:mm");
    },
    daysAfter(date, days) {
        if (!days) {
            days = 1;
        }
        return dayjs(date)
            .add(days, "days")
            .format("YYYY-MM-DD");
    },
    monthsBefore(date, months) {
        if (!months && months !== 0) {
            months = 1;
        }
        return dayjs(date)
            .subtract(months, "months")
            .format("YYYY-MM-DD");
    },
    monthsAfter(date, months) {
        if (!months && months !== 0) {
            months = 1;
        }
        return dayjs(date)
            .add(months, "months")
            .format("YYYY-MM-DD");
    },
    lastWeek() {
        const dateNow = this.dateNow();
        return dayjs(dateNow)
            .subtract(1, "weeks")
            .format("YYYY-MM-DD HH:mm");
    },
    startOfYear() {
        return dayjs(this.dateNow()).startOf("year").format("YYYY-MM-DD");
    },
    endOfYear() {
        return dayjs(this.dateNow()).endOf("year").format("YYYY-MM-DD");
    },
    endOfMonth(date) {
        return dayjs(date).endOf("month").format("YYYY-MM-DD");
    },
    startOfMonth(date) {
        return dayjs(date).startOf("month").format("YYYY-MM-DD");
    },
    getFormatedTime(date) {
        return dayjs(date).format("HH:mm");
    },
    getFormatedDate(date) {
        return dayjs(date).format("YYYY-MM-DD HH:mm");
    },
    getFormatedDateWithoutTime(date) {
        return dayjs(date).format("MMM DD, YYYY");
    },
    userTimezone() {
        // Returns time zone difference in minutes, eg -60 for UTC +1
        const timedifference = new Date().getTimezoneOffset();

        // Invert the result and divide by 60 to get in hours. Eg, -60 becomes +1
        return (timedifference * -1) / 60;
    },
    currentYear()
    {
        return dayjs().format("YYYY");
    },
    setAccountingToYear(from)
    {
        return this.dateToDateWithoutHour(dayjs(from).add(1, "years").subtract(1, "days"));
    },
    isBefore(date, comparedate)
    {
        var d = dayjs(date);
        var c = dayjs(comparedate);
        return d.isBefore(c, "day");
    },
    isBeforeNrDays(date, nrDays){
        var compareDate = this.add(dayjs(), "day", nrDays);
        return this.isBefore(date, compareDate);
    },
    isAfter(date, comparedate)
    {
        var d = dayjs(date);
        var c = dayjs(comparedate);
        return d.isAfter(c, "day");
    },
    isAfterNrDays(date, nrDays){
        var compareDate = this.add(dayjs(), "day", nrDays);
        return this.isAfter(date, compareDate);
    },
    isValidStringDate(dateString) {
        var date = dayjs(dateString, 'YYYY-MM-DD', true);
        var isValid = date.isValid();
        return isValid;
    },
    add(date, type, val){
        return dayjs(date).add(val, type);
    },
    dateInSpan(date, from, to){
        var inspan = this.isAfter(date, from) && this.isBefore(date, to);
        if(inspan)
            return true;
        // kolla om ligger på gränsen, dvs samma som from eller to
        var cdate = this.custom(date);
        var cfrom = this.custom(from);
        var cto = this.custom(to);
        if(cdate == cfrom || cdate == cto)
            return true;
        return false;
    },
    parse(datestring, formats = ["YYYY-MM-DD"]){
        // test all formats
        for(var i = 0; i < formats.length; i++){
            var parsed = dayjs(datestring, formats[i], true);
            if(parsed.isValid())
                return parsed.format("YYYY-MM-DD");
        }
        return false;
    },
    isSameDay(date1, date2){
        var d1 = this.custom(date1);
        var d2 = this.custom(date2);
        if(d1 == d2)
            return true;
        return false;
    },
    isBankDay(date){
        var d = dayjs(date);
        var dayOfWeek = d.isoWeekday();
        if( dayOfWeek >= 6){
            return false;
        }
        // kolla om röd dag
        return true;
    },
    secondsToTime(seconds, format){
        if(!format)
            format = "mm:ss";
        return dayjs.duration(seconds, 'seconds').format(format);
    }
}
